@keyframes showIn {
  0% {
    opacity: 0;
    transform: translateY(-25%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal {
  @media (--md-min) {
    orama-input {
      padding: 0;
      margin: 0;
      border-radius: 0;
    }

    input[type='search'] {
      border-radius: var(--radius-m, $radius-m) var(--radius-m, $radius-m) 0 0;
    }
  }
}

.main {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
}

.section-active {
  display: flex;
  overflow: hidden;
}

.section-inactive {
  display: none;
}
